import moment from 'moment';

import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useQueryFilters } from 'hooks';
import { OrderFilters } from 'types';

import { ManageOrdersList } from '../ManageOrderList';

export const CompletedOrders: React.FC = () => {
  useQueryFilters<OrderFilters>({
    from: moment().subtract(1, 'w').startOf('d').toISOString(),
  });

  return (
    <ManageOrdersList
      tab={OrdersTab.Completed}
      additionalColumns={[
        AdditionalOrderColumn.OrderProcessedBy,
        AdditionalOrderColumn.TraderPayment,
        AdditionalOrderColumn.CustomerRequisites,
        AdditionalOrderColumn.Validation,
      ]}
    />
  );
};
